// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"2ddea01a","494":"0c8bc5f7","511":"5cde82d8","572":"11aa536f","617":"8f8003cd","710":"b7c47b12","857":"3b160124"}[chunkId] + ".chunk.js";
};